'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PreviewBooking = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(PreviewBooking, _Component);

  function PreviewBooking() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PreviewBooking);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PreviewBooking.__proto__ || (0, _getPrototypeOf2.default)(PreviewBooking)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PreviewBooking, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          _props$data = _props.data,
          shop = _props$data.shop,
          time = _props$data.time,
          slot = _props$data.slot,
          services = _props$data.services,
          note = _props$data.note,
          price = _props$data.price,
          customer = _props$data.customer,
          onClick = _props.onClick;

      var styles = require('./PreviewBooking.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.box + ' ' + (className ? className : '') },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/' + shop.handle, style: { color: '#666' } },
          _react2.default.createElement(
            'div',
            { className: styles.boxHead },
            _react2.default.createElement(
              'div',
              { className: styles.shopName },
              shop.name
            ),
            _react2.default.createElement(
              'div',
              { className: styles.shopCat },
              shop.category
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.boxContent },
          _react2.default.createElement(
            'div',
            { className: styles.infoDetail },
            _react2.default.createElement(
              'div',
              { className: styles.row },
              _react2.default.createElement(_components.PreviewLabel, {
                className: styles.time,
                name: 'Th\u1EDDi Gian',
                sub: time,
                iconUrl: '/booking/time.png'
              }),
              _react2.default.createElement(_components.PreviewLabel, {
                name: 'S\u1ED1 ch\u1ED7',
                sub: slot,
                iconUrl: '/booking/friend.png'
              })
            ),
            _react2.default.createElement(_components.PreviewLabelForService, {
              className: styles.marginTop,
              name: 'D\u1ECBch v\u1EE5',
              sub: services,
              iconUrl: '/booking/star.png'
            }),
            note && note.length && note[0] !== '' && _react2.default.createElement(_components.PreviewLabel, {
              className: styles.marginTop,
              name: 'Ghi ch\xFA',
              sub: note,
              iconUrl: '/booking/note.png'
            }),
            !!customer && _react2.default.createElement(_components.PreviewLabel, {
              className: styles.marginTop,
              name: 'Kh\xE1ch h\xE0ng',
              sub: customer,
              iconUrl: '/booking/contact.png'
            })
          ),
          _react2.default.createElement('div', { className: styles.dash }),
          _react2.default.createElement(
            _components.PreviewLabel,
            {
              className: styles.total,
              name: 'T\u1ED5ng ti\u1EC1n',
              sub: price,
              iconUrl: '/booking/money.png'
            },
            _react2.default.createElement(
              'div',
              { className: styles.btnDetail, onClick: onClick },
              _react2.default.createElement(
                'span',
                null,
                '(Chi ti\u1EBFt)'
              )
            )
          )
        )
      );
    }
  }]);
  return PreviewBooking;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.object,
  className: _react.PropTypes.string,
  onClick: _react.PropTypes.func
}, _temp2);
exports.default = PreviewBooking;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/PreviewBooking.js
// module id = 1564
// module chunks = 0